/* One line, quiet: this states a fact about the window; it is not an alarm. */
.banner {
  margin: 0 0 10px;
  padding: 1px 0 1px 10px;
  border-left: 2px solid var(--line-2);
  color: var(--ink-2);
  font-size: var(--t-min);
  line-height: 1.55;
  max-width: 92ch;
}

.banner strong {
  color: var(--ink);
}
